import * as React from 'react';
import { useCallback, useState } from 'react';
import StoreFlag from './store_flag';
import styled from 'styled-components';
import { color, space, fontFamily, fontSize } from '@core-ds/primitives';
import { CaretDown, CaretUp } from '@core-ds/icons/16';
import withTippy from '../../dropdowns/with_tippy';
import StoreDropdown from './store_dropdown';

const StyledCaretDown = styled(CaretDown)`
   color: ${color.gray6};
`;

const StyledCaretUp = styled(CaretUp)`
   color: ${color.white};
`;

const Button = styled.a`
   display: flex;
   align-items: center;
   padding: 20px ${space[5]} ${space[4]} 0;

   :hover {
      text-decoration: none;

      ${StyledCaretDown} {
         color: ${color.white};
      }
   }
`;

const ButtonWithTippy = withTippy(Button);

const Currency = styled.div`
   font-family: ${fontFamily.lato};
   font-style: normal;
   font-weight: bold;
   font-size: ${fontSize[0]};
   line-height: 1;
   color: ${color.white};
   margin-right: ${space[2]};
`;

const StoreSelector = ({ stores, dropdownState }) => {
   const currentStore = stores.find(store => store.isDisplayStore);

   const [dropdownOpen, setDropdownOpen] = dropdownState;

   return (
      <ButtonWithTippy
         id="storeDropdownToggle"
         offset="90, -20"
         onShow={() => setDropdownOpen(true)}
         onHide={() => setDropdownOpen(false)}
         content={<StoreDropdown currentStore={currentStore} stores={stores} />}
      >
         <StoreFlag
            storeCode={currentStore.storeCode}
            style={{
               marginRight: '8px',
            }}
            id="currentStore"
         />
         <Currency>{currentStore.currency}</Currency>
         {dropdownOpen ? <StyledCaretUp /> : <StyledCaretDown />}
      </ButtonWithTippy>
   );
};

export default StoreSelector;
